import * as React from "react"
import { SearchX } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useBookingT } from "@/hooks/use-translations"

type Props = {
  onReset?: () => void
}

export function EmptyState({ onReset }: Props) {
  const t = useBookingT()
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-neutral-300 bg-white py-12 text-center">
      <SearchX className="size-10 text-neutral-500 mb-3" />
      <h3 className="text-base font-medium text-neutral-900">
        {t("integrations_empty_title", "No integrations found")}
      </h3>
      <p className="mt-1 max-w-md text-sm text-neutral-600">
        {t("integrations_empty_desc", "Try adjusting your search or filter")}
      </p>
      {onReset && (
        <Button variant="outline" className="mt-4" onClick={onReset}>
          {t("integrations_empty_reset", "Reset filters")}
        </Button>
      )}
    </div>
  )
}
